import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import "./index.css";
import App from "./App.vue";
import router from "./router/index";
import { createMetaManager } from "vue-meta";

import de from "./assets/locales/de.json";
import en from "./assets/locales/en.json";
import fr from "./assets/locales/fr.json";
import it from "./assets/locales/it.json";
import es from "./assets/locales/es.json";
import nl from "./assets/locales/nl.json";
import pl from "./assets/locales/pl.json";
import sv from "./assets/locales/sv.json";
import pt from "./assets/locales/pt.json";
import ru from "./assets/locales/ru.json";
import da from "./assets/locales/da.json";
import nb from "./assets/locales/nb.json";
import el from "./assets/locales/el.json";
import hu from "./assets/locales/hu.json";

const messages = { en, de, fr, it, es, nl, pl, sv, pt, ru, da, nb, el, hu };
const supported = Object.keys(messages);

function pickInitialLocale() {
  try {
    const url = new URL(window.location.href);
    const param = url.searchParams.get("lang");
    if (param && supported.includes(param)) return param;
  } catch {}
  try {
    const saved = window.localStorage.getItem("hundeo-app:locale");
    if (saved && supported.includes(saved)) return saved;
  } catch {}
  // Browser language with aliases ("no" → "nb", "pt-BR" already strips to "pt").
  const raw = (navigator.language || "en").toLowerCase();
  const base = raw.split("-")[0];
  const aliases = { no: "nb" };
  const candidate = aliases[base] || base;
  if (supported.includes(candidate)) return candidate;
  return "en"; // English fallback when browser language is unsupported
}

const initial = pickInitialLocale();

const i18n = createI18n({
  locale: initial,
  fallbackLocale: "en",
  allowComposition: true,
  messages,
});

if (typeof document !== "undefined") {
  document.documentElement.lang = initial;
}

createApp(App).use(router).use(createMetaManager()).use(i18n).mount("#app");
